import { render, staticRenderFns } from "./InvestorOnboardingStepPage.vue?vue&type=template&id=e82177ae&"
import script from "./InvestorOnboardingStepPage.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingStepPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports